import React from 'react';
import rehypeKatex from 'rehype-katex';
import remarkMath from 'remark-math';
import remarkGfm from 'remark-gfm';
import ReactMarkdown from 'react-markdown';
import TextCursor from '../TextCursor/TextCursor';
import styles from './GeneratedContent.module.scss';
import { textContentSelector } from '../../utilities/constants/common';

interface Props {
  text: string;
  isTextGenerating: boolean;
}

const GeneratedContent: React.FC<Props> = (props) => {
  const { text, isTextGenerating } = props;

  return (
    <div className={styles.contentWrapper}>
      <div className={`text-content ${textContentSelector}`}>
        <ReactMarkdown
          // eslint-disable-next-line react/no-children-prop
          children={text}
          remarkPlugins={[remarkMath, remarkGfm]}
          rehypePlugins={[
            [rehypeKatex, { throwOnError: false, strict: 'ignore' }],
          ]}
        />

        {isTextGenerating && <TextCursor />}
      </div>
    </div>
  );
};

export default GeneratedContent;
